/**
 * 定义一些通用枚举常量
 * 用于 Vue filter 和 页面 select 等
 */
 import i18n from '@/common/i18n/index.js'

/**
 * 设备类型,不同设备类型进行不同的业务逻辑处理
 */
 export const HELMET_TYPE = [
  // HW-IH-0500,HW-IH-0510
  { value: 0, label: i18n.t('deviceIH5') },
  // HW-IH3,HW-IH-21DW,HW-IH-40,HW-IH-20,HW-IH-20P,HW-IH-0600,HW-IH-0401,HW-IH-0301
  { value: 1, label: i18n.t('deviceIH6') },
  // HW-ZFY-0200
  { value: 2, label: i18n.t('deviceZFY') },
  // IPC
  { value: 3, label: i18n.t('deviceIPC') },
  // 定位设备
  { value: 4, label: i18n.t('locater') },
]
